import axios from 'axios';
import React, { useEffect } from 'react';
import {jwtDecode} from 'jwt-decode'; // Corrected import statement
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { urls } from './Urls';


const OAuth2Callback = () => {
  const location = useLocation();
  const history = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  let refreshInterval=null;

  useEffect(() => {
    const fetchToken = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');

      if (code) {
        try {
          const getTokenParams = {
            code: code,
            client_id: process.env.REACT_APP_CONSUMER_KEY,
            client_secret: process.env.REACT_APP_CONSUMER_SECRET,
            redirect_uri: process.env.REACT_APP_REDIRECT_URL, 
            grant_type: 'authorization_code',
          };

          console.log(getTokenParams);

          const response = await axios.post(process.env.REACT_APP_TOKEN,null,{params:getTokenParams}, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          });

          const data = response.data;
          console.log("response:",data);
          const { access_token, refresh_token, id_token,sfdc_community_id} = data;

          localStorage.setItem('jwt_token', access_token);
          localStorage.setItem('refresh_token', refresh_token);
          localStorage.setItem('id_token', id_token);
          localStorage.setItem('sso_id', sfdc_community_id);

          fetchUserDetails(id_token);
          refreshTokenTimer(refresh_token);

        } catch (error) {
          console.error('Error fetching token:', error);
          if (error.response) {
            console.error('Error response data:', error.response.data);
            console.error('Error response status:', error.response.status);
            console.error('Error response headers:', error.response.headers);
          }

        }
      }
    };

    fetchToken();
  }, []);


  const fetchUserDetails = async (id_token) => {
    if (!id_token || id_token.split('.').length !== 3) {
      console.error('Invalid token format');
      alert('Invalid token received. Please try logging in again.');
      history('/user-profile-selection');
      return;
    }
  
    try {
      const decodedAccessToken = jwtDecode(id_token);
      console.log('Decoded access token:', decodedAccessToken);
 
      const { custom_attributes } = decodedAccessToken;
  
      if (custom_attributes) {
        const { First_Name, Last_Name,UserEmail,City,Role,Business_Industry} = custom_attributes;
        localStorage.setItem('user', JSON.stringify({ First_Name, Last_Name,UserEmail,City,Role,Business_Industry }));
        console.log('User details:', First_Name, Last_Name);
        history('/home');
      } else {
        console.error('Missing custom attributes in token');
     //   alert('Token is missing user details. Please try logging in again.');
        history('/home');
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      history('/home');
    }
  };
  

  const refreshToken = async (refresh_token) => {
    const getTokenParams = {
         refresh_token: refresh_token,
        client_id: process.env.REACT_APP_CONSUMER_KEY,
        client_secret: process.env.REACT_APP_CONSUMER_SECRET,
        grant_type: 'refresh_token',
    };

    
    try {
      const response = await axios.post(process.env.REACT_APP_TOKEN,null,{params:getTokenParams}, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      const data = response.data;
      const { access_token, new_refresh_token } = data;
      console.log('refreshTokens:', data);
      localStorage.setItem('jwt_token', access_token);
      localStorage.setItem('refresh_token', new_refresh_token || refresh_token);
    } catch (error) {
      console.error('Error refreshing token:', error);
     // alert('An error occurred. Please try logging in again.');
      history('/home');
    }
  };

  const refreshTokenTimer = (refresh_token) => {
    const refreshInterval = 15 * 60 * 1000; // Refresh token every 15 minutes
    setInterval(() => {
      refreshToken(refresh_token);
    }, refreshInterval);
  };

  const isTokenExpired = (token) => {
    
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Current time in seconds
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true; // Treat invalid token as expired
    }
  };

  const checkAndRefreshToken = async () => {
    const access_token = localStorage.getItem('id_token');
    const refresh_token = localStorage.getItem('refresh_token');

    console.log('Access token:', access_token);
    console.log('Refresh token:', refresh_token);

  
    if (!access_token) {
      console.error('No access token found');
      return; // Exit if there's no access token
    }
  
    if (isTokenExpired(access_token)) {
      await refreshToken(refresh_token);
    }
  };
  

  useEffect(() => {
    checkAndRefreshToken();
  }, []);


 
  return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <CircularProgress size={'10rem'} color='error'/>

  </div>;
};

export default OAuth2Callback;